<template>
  <div class="mt-2">
    <form data-vv-scope="sign-document">
      <div class="row">
        <vs-select
          class="col-12 mb-2"
          autocomplete
          label="Seleccione tipo de Firma"
          v-model="signType"
          name="sign"
          data-vv-as="tipo de firma"
          :danger="errors.has('sign-document.sign')"
          :danger-text="errors.first('sign-document.sign')"
          v-validate="'required'"
        >
          <vs-select-item
            :value="firma"
            :text="providerName(firma.proveedor)"
            v-for="firma in userSignConfiguration.userSigns"
            :key="firma.id"
            :disabled="firma.proveedor === signerProviderConfigs.ASignAPI.key && firma.atendida"
            :title="firma.proveedor === signerProviderConfigs.ASignAPI.key ?
            'Esta firma no está habilitada para firma masiva' : ''"
          />
        </vs-select>
        <vs-input
          v-if="signerProviderConfig.otp"
          autocomplete="off"
          class="col-12 mb-2"
          label="Código OTP"
          maxlength="6"
          name="otp"
          v-model="otpCode"
          v-validate="'required'"
          :danger="errors.has('sign-document.otp')"
          :danger-text="errors.first('sign-document.otp')"
        />
        <vs-input
          autocomplete="off"
          v-if="signerProviderConfig.password"
          class="col-12"
          type="password"
          label="Contraseña de certificado"
          name="certificatePassword"
          v-model="certificatePassword"
          v-validate="'required|min:6'"
          :danger="errors.has('sign-document.certificatePassword')"
          :danger-text="errors.first('sign-document.certificatePassword')"
        />
      </div>
    </form>
    <b-overlay :show="loading">
      <div class="row">
        <div class="col-12 text-right">
          <b-button
            class="mr-2"
            data-cy="process-massive-button"
            variant="primary"
            size="sm"
            @click="sendAction"
          >
            Firmar documentos
          </b-button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import { signerProviderConfigs } from '@/febos/chile/approvals/components/trays/managementTray/constants';

export default {
  name: 'ModalSignProcess',
  components: {},
  data() {
    return {
      error: {
        message: ''
      },
      loading: false,
      otpCode: '',
      signType: '',
      certificatePassword: '',
      signerProviderConfigs,
      signerProviderConfig: {},
      metadata: {}
    };
  },
  watch: {
    signType(sign) {
      this.$emit('selectedSign', sign);
      this.configActiveSigner();
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'userSignConfiguration'
    ]),
    providerName() {
      return (provider) => this.signerProviderConfigs[provider]?.description || provider;
    },
    action() {
      return 'Firmar';
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'signMassiveFiles'
    ]),
    cancelProcess() {
      this.comment = '';
      this.commentFiles = [];
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    makeObjectRequest() {
      const action = 'firmar';
      const body = {
        llamadas: this.selectedFlows.map((flow) => ({
          estado: action.toUpperCase(),
          pasoId: flow.pasoActualId,
          ejecucionId: flow.idAprobacion,
          aprobacionId: '0',
          documentoId: flow.documentoId,
          codigoAutenticador: this.otpCode,
          password: this.password || 'na',
          tipoFirma: this.signType.tipo,
          idDigitalFirma: this.signType.id,
          OTP: this.otpCode,
          pais: 'cl',
          functionClass: 'cl.febos.aprobaciones.acciones.ejecucion.firmar.HandlerClAprobacionesFirmar',
          requestClass: 'cl.febos.aprobaciones.acciones.ejecucion.firmar.RequestClAprobacionesFirmar',
          responseClass: 'cl.febos.aprobaciones.acciones.ejecucion.firmar.ResponseClAprobacionesFirmar',
          coordenadaX: null,
          coordenadaY: null,
          paginaFirma: null,
          cordenadasAlto: null,
          cordenadasAncho: null
        }))
      };
      const requestParams = {
        OTP: this.otpCode,
        codigoAutenticador: this.otpCode,
        idDigitalFirma: this.signType.id,
        password: this.password || 'na',
        tipoFirma: this.signType.tipo
      };

      return { requestParams, body };
    },
    async sendAction() {
      const isValid = await this.validateForm('sign-document');
      if (!isValid) {
        return;
      }
      try {
        this.loading = true;
        await this.signMassiveFiles(this.makeObjectRequest());
        this.loading = false;
        this.comment = '';
        this.commentFiles = [];
        await this.$emit('close-modal');
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.loading = true;
      this.sendAction();
    },
    configActiveSigner() {
      if (this.signType && this.signType.proveedor) {
        this.signerProviderConfig = this.signerProviderConfigs[this.signType.proveedor];
        if (this.signerProviderConfig.configureOnSelect) {
          this.signerProviderConfig.configureOnSelect(this.signType, this.signerProviderConfig);
        }
      } else {
        this.signerProviderConfig = {};
      }
      console.log('this.signerProviderConfig', this.signerProviderConfig);
    },
    mounted() {
      this.signerProviderConfig = {};
      this.meta = {};
      const [signSelected] = this.userSignConfiguration.userSigns;
      const segPresSign = this.userSignConfiguration.userSigns
        .find((sign) => sign.proveedor.includes('Segpres'));
      if (segPresSign) {
        this.signType = segPresSign;
      } else {
        this.signType = signSelected;
      }
    }
  },
  props: {
    process: { type: String, required: true },
    selectedFlows: { type: Array, required: true },
  }
};
</script>
